import React from "react";

import NicheMenuIcon from "root/icons/NicheMenu";

// ----------------------------------------------------------------------------------
const seoSection = {
  type: "section",
  id: "seo",
  title: "SEO",
  icon: NicheMenuIcon,
  children: [
    {
      title: "SEO-тексты",
      url: "/chat-gpt",
      component: React.lazy(() => import("root/pages/chatGPT/App")),
    },
    {
      title: "Индексация запросов",
      url: "/keywords-position",
      component: React.lazy(() => import("root/pages/keywords-position/App")),
    },
    {
      title: "Индексация запросов v2",
      url: "/product_positions",
      component: React.lazy(() => import("root/pages/product_positions/App")),
      noProd: true,
    },
    {
      title: "Позиции в поиске",
      url: "/position",
      component: React.lazy(() => import("root/pages/position/App")),
    },
    {
      title: "Кластеризатор",
      url: "/clusterer",
      component: React.lazy(() => import("root/pages/clusterer/App")),
    },
    {
      title: "Группировка запросов",
      url: "/grouping",
      component: React.lazy(() => import("root/pages/groupingNew/App")),
    },
    {
      title: "Популярность запросов",
      url: "/keystat",
      component: React.lazy(() => import("root/pages/keystat/App")),
    },
    {
      title: "Поисковые подсказки",
      url: "/keys-finder",
      component: React.lazy(() => import("root/pages/keys-finder/App")),
    },
    {
      title: "Запросы у списков",
      url: "/articles-keys",
      component: React.lazy(() => import("root/pages/articles-keys/App")),
    },
    {
      title: "Запросы у топов поиска",
      url: "/keys-top-find",
      component: React.lazy(() => import("root/pages/keys-top-find/App")),
    },
    {
      title: "Пылесос запросов",
      url: "/sellers-keys",
      component: React.lazy(() => import("root/pages/sellers-keys/App")),
    },
    {
      title: "Сравнение списков",
      url: "/keys-comparison",
      component: React.lazy(() => import("root/pages/keys-comparison/App")),
    },
    {
      title: "Вхождение запросов",
      url: "/check-products-by-keys/product",
      component: React.lazy(() =>
        import("root/pages/check-products-by-keys/input/components/Product")
      ),
    },
    {
      title: "SEO-AI",
      url: "/seo-ai",
      component: React.lazy(() => import("root/pages/seo-ai/App")),
    },
    // {
    // 	title: "Оптимизация рекламы",
    // 	url: "/advertising-optimization",
    // 	component: React.lazy(() =>
    // 		import("root/pages/advertising-optimization/App")
    // 	),
    // 	exact: false,
    // },

    //? {
    //? 	title: "Трекер позиций",
    //? 	disabled: true,
    //? },
    {
      title: "UTM ссылки",
      url: "/utm-links",
      component: React.lazy(() => import("root/pages/utm-generator/App")),
    },
  ],
};

export default seoSection;
